export const TreeDT = {
	tree: {
		css: ({ dt }) => `
          .p-tree-align-labels {
              .p-tree-node-label {
                flex: 1;
              }
          }
        `,
	},
};
